import {
  createAnonymousRoute,
  createAuthenticatedRoute,
  createHybridRoute,
  createLoginPage,
  createForgotPasswordPage,
  createRegisterPage,
  createResetPasswordPage,
  ForgotPasswordConfirmPage as EntoroForgotPasswordConfirmPage,
} from 'entoro-shared';
import withLayout from './withLayout';
import { currentInvestorUserQuery } from '../apollo';

const userType = 'INVESTOR';

export const AnonymousRoute = createAnonymousRoute({
  redirect: '/dashboard',
});

export const AuthenticatedRoute = createAuthenticatedRoute({
  userQuery: currentInvestorUserQuery,
  getUserFromData: ({ currentInvestorUser }) => currentInvestorUser,
});

export const HybridRoute = createHybridRoute({
  userQuery: currentInvestorUserQuery,
  getUserFromData: ({ currentInvestorUser }) => currentInvestorUser,
});

export const ForgotPasswordPage = withLayout(
  createForgotPasswordPage({
    userType,
  })
);

export const ForgotPasswordConfirmPage = withLayout(
  EntoroForgotPasswordConfirmPage
);

export const LoginPage = withLayout(
  createLoginPage({
    userType,
    redirect: '/dashboard',
  })
);

export const RegisterPage = withLayout(
  createRegisterPage({
    userType,
    redirect: '/account',
  })
);

export const ResetPasswordPage = withLayout(
  createResetPasswordPage({
    userType,
    redirect: '/dashboard',
  })
);



// WEBPACK FOOTER //
// ./src/components/shared.js